<template>
	<!-- PCT专利查询 -->
  <el-row>
    <div class="queryParamStyle">
      <el-row>
        <el-form :model="queryParams" ref="queryParams" :inline="true" label-width="100px">
          <el-col :span="12">
            <el-form-item label="申请号：" prop="sqh">
              <el-input   style="width: 300px"
                      v-model="queryParams.sqh"
                      placeholder="请输入申请号"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国际申请日：" prop="gjsqDate">
              <el-date-picker
                      style="width: 300px"
                      size="small"
                      v-model="gjsqDates"
                      @change="changeGjsqDate"
                      type="daterange"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="请选择开始日期"
                      end-placeholder="请选择截止日期"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主分类号：" prop="zflh">
              <el-input
                      style="width: 300px"
                      v-model="queryParams.zflh"
                      placeholder="请输入主分类号"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请人地址：" prop="sqrjd">
              <el-input   style="width: 300px"
                      v-model="queryParams.sqrjd"
                      placeholder="请输入申请人地址"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="getList()" style="margin-right: 20px">检 索</el-button>
              <!--<el-button type="primary" icon="el-icon-refresh" size="mini" @click="getList" style="margin-right: 20px">重 置</el-button>-->
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>
    <el-divider></el-divider>
    <div class="search-table">
      <el-table v-loading="loading" :data="list" tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
        <el-table-column label="序号" align="center" type="index" width="50px"/>
        <el-table-column label="申请号" align="center" prop="sqh" :show-overflow-tooltip="true" width="180px"/>
        <el-table-column label="主分类号" align="center" prop="zflh" :show-overflow-tooltip="true" />
        <el-table-column label="申请人地址" align="center" prop="sqrjd" width="120" :show-overflow-tooltip="true"/>
        <el-table-column label="收到日" align="center" prop="sdr">
			<template slot-scope="scope">
				<span>
					{{parseTime(scope.row.sdr,'{y}-{m}-{d}')}}
				</span>
			</template>
		</el-table-column>
        <el-table-column label="国际申请日" align="center" prop="gjsqr">
			<template slot-scope="scope">
				<span>
					{{parseTime(scope.row.gjsqr,'{y}-{m}-{d}')}}
				</span>
			</template>
		</el-table-column>
      </el-table>
      <pagination
		  v-show="total>0"
		  :total="total"
		  :page.sync="queryParams.pageNum"
		  :limit.sync="queryParams.pageSize"
		  @pagination="getList"
      />
    </div>

  </el-row>

</template>
<script>
import { listPtc } from "@/api/zscq/ptc";
  export default {
    //首页
    name: 'yxfmzlcx',
    data(){
      return {
        // 遮罩层
        loading: false,
        // 总条数
        total: 0,
        list:[],
        queryParams:{
          pageNum:1,
          pageSize:10,
          sqh: undefined,
          gjsqDate: undefined,
          zflh: undefined,
          sqrjd: undefined,
          gjsqrStartTime: undefined,
          gjsqrEntTime: undefined,
        },
        gjsqDates: undefined,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
      this.getList();
    },
    methods:{
      getList() {
        this.loading = true;
		listPtc(this.queryParams).then(response => {
		    this.list = response.rows;
		    this.total = response.total;
		    this.loading = false;
		});
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
		this.resetQuery();
      },
      changeGjsqDate(value) {
          if (value != undefined && value != '' && value != null) {
              this.queryParams.gjsqrStartTime = value[0]
              this.queryParams.gjsqrEntTime = value[1]
          }
      },
	  /** 重置按钮操作 **/
	  resetQueryAndGetList() {
	    this.queryParams = {};
	    this.gjsqDates = undefined;
		this.getList();
	  },
    }
  }
</script>
<style scoped>
  .el-form-item{
    margin-bottom: 8px;
  }
  .queryParamStyle{
    padding-top: 10px;
  }
  .el-divider--horizontal{
    display: block;
    height: 1px;
    width: 100%;
    margin: 8px 0;
  }
</style>
